import { IUserContext } from "Interfaces/Providers/User";
import { UserContext } from "providers/User/UserProvider";
import { useContext } from "react";

export default function useUser(): IUserContext {
  const context = useContext(UserContext);

  return context;
}
